export default function () {
  return {
    cachesearches: [],
    cachesearchesCurrentPage: 1,
    cachesearchesLastPage: 1,
    cachesearchesPerPage: 0,
    cachesearchesTotal: 0,
    cachesearchesLoading: false,
    indexPage: null
  }
}
